import React from 'react';
import {Button, ConfigProvider} from "antd";
import {ButtonProps} from "antd/lib/button/button";
import IconDone from "../icons/IconDone";
import {t} from "i18next";

interface ButtonCompareProps extends ButtonProps {
  compared: boolean,
}

export default function ButtonCompare({...props}: ButtonCompareProps) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: props.compared ? '#DBF4E3' : '#F3F6F8',
        },
      }}
    >
      <Button
        type={"primary"} {...props}
        style={{
          color: props.compared ? '#044319' : '#384146',
          fontSize: '12px',
          fontWeight: 600,
          lineHeight: '18px',
        }}
        icon={<IconDone/>}
      >
        {props.compared ? t('planner.inCompare') : t('planner.compare')}
      </Button>
    </ConfigProvider>
  )
}
